import styled, { from, to } from 'theme';

export const FooterBottomWrapper = styled.div`
  background-color: white;
  padding: 1rem 2rem;
  margin: 0 -2rem;
  font-size: 0.75rem;
  color: ${props => props.theme.variables.customColors.lightGreyText};
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${from('md')} {
    padding: 1rem 8rem;
    margin: 0rem -8rem;
  }

  ${to('md')} {
    flex-flow: column;
    align-items: flex-start;
  }
`;

export const FooterBottomSocial = styled.div`
  display: flex;

  a {
    width: 1.75rem;
    height: 1.75rem;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }
  }

  ${to('md')} {
    order: -1;
    margin: 2rem 0 1rem;
  }
`;
